import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Steps } from 'antd';
import throttle from 'lodash.throttle';
import { BodyTextValue } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Step } = Steps;

const ResponsiveHeader = () => {
    const mobileBreakPoint = 772;
    const applyViewportChange = 250;

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    // const [selected, setSelected] = useState('1');
    const [viewportWidth, setViewportWidth] = useState(0);

    // Function to handle viewport dimension changes
    const saveViewportDimensions = useCallback(
        throttle(() => {
            setViewportWidth(window.innerWidth);
        }, applyViewportChange),
        [applyViewportChange]
    );

    // useEffect to handle component mount and unmount for event listeners
    useEffect(() => {
        saveViewportDimensions(); // Initial call to set viewport width
        window.addEventListener('resize', saveViewportDimensions);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', saveViewportDimensions);
        };
    }, [saveViewportDimensions]);

    const isConsultTypeOnline = 'online';

    // Mobile or desktop view handling based on viewport width
    const renderSteps = () => {
        if (isConsultTypeOnline) {
            if (viewportWidth > mobileBreakPoint) {
                return (
                    <Row type="flex" justify="center">
                        <Col xs={24} lg={20} xl={18} xxl={18} md={24} sm={24} style={{ marginBottom: '3%' }}>
                            <Steps current={2}>
                                <Step title={<BodyTextValue text = {langdata.ChooseTime ? langdata.ChooseTime : 'Choose Time'} />} />
                                <Step title={<BodyTextValue text = {langdata.ChooseLocation ? langdata.ChooseLocation : 'Choose Location'} />} />
                                <Step title={<BodyTextValue text = {langdata.MakePayment ? langdata.MakePayment : 'Make Payment'} /> } />
                                <Step title={<BodyTextValue text = {langdata.BookingSummary ? langdata.BookingSummary : 'Booking Summary'} />} />
                            </Steps>
                        </Col>
                    </Row>
                );
            }
            return (
                <Row type="flex" justify="center">
                    <Col xs={24} sm={24} style={{ marginBottom: '3%' }}>
                        <Steps current={2} responsive={false}>
                            <Step size="small" 
                                title={<span style={{ fontSize: viewportWidth < 460 ? '7px': '' }}>
                                    {langdata.Select ? langdata.Select : 'Select'}
                                </span>}
                            />
                            <Step size="small" title={<span style={{ fontSize: viewportWidth < 460 ? '7px': '' }}>
                                {langdata.Location ? langdata.Location : 'Location'}
                            </span>}
                            />
                            <Step size="small" title={<span style={{ fontSize: viewportWidth < 460 ? '7px': '' }}>
                                {langdata.Pay ? langdata.Pay : 'Pay' }</span>}
                            />
                            <Step size="small" title={<span style={{ fontSize: viewportWidth < 460 ? '7px': '' }}>
                                {langdata.Confirm ? langdata.Confirm : 'Confirm'}</span>}
                            />
                        </Steps>
                    </Col>
                </Row>
            );
        }
            
        if (viewportWidth > mobileBreakPoint) {
            return (
                <Row type="flex" justify="center">
                    <Col lg={12} md={14} style={{ marginBottom: '3%' }}>
                        <Steps current={2} xs={2}>
                            <Step title={<BodyTextValue text = {langdata.ChooseTime ? langdata.ChooseTime : 'Choose Time'}/> } />
                            <Step title={<BodyTextValue text = {langdata.MakePayment ? langdata.MakePayment : 'Make Payment'} /> } />
                            <Step title={<BodyTextValue text = {langdata.BookingSummary ? langdata.BookingSummary : 'Booking Summary'} /> } />
                        </Steps>
                    </Col>
                </Row>
            );
        }
            
        return (
            <Row type="flex" justify="center">
                <Col xs={0} md={14} style={{ marginBottom: '3%' }}>
                    <Steps current={2} xs={24}>
                        <Step style={{ float: 'left', marginLeft: '-20px' }} title={<BodyTextValue text = {langdata.Select ? langdata.Select : 'Select'}/> } />
                        <Step style={{ float: 'left', marginLeft: '-22px' }} title={<BodyTextValue text = {langdata.Pay ? langdata.Pay : 'Pay'} /> } />
                        <Step style={{ float: 'left', marginLeft: '-23px' }} title={<BodyTextValue text = {langdata.Confirm ? langdata.Confirm : 'Confirm'} /> } />
                    </Steps>
                </Col>
            </Row>
        );
    };

    return <div>{renderSteps()}</div>;
};


export default ResponsiveHeader;
